export const stripe = {
  subTitle:
    "Link your Stripe account to charge your clients for reservations quickly and easily, avoiding online travel agency commissions.",
};
